import NextLink from "next/link";
import { useTranslation } from "next-i18next";
import { css } from "@emotion/react";
import Box from "@mui/material/Box";
import Button from "@ds/components/Button";
import Text from "@ds/components/Text";
import type { TImage } from "../../type";
import { IMG_WHATSAPP } from "@config/images";
import useStyles from "@containers/ProductLevelOne/libs/Desktop/styles";
import getAdminWA from "@helpers/getAdminWA";
import { gtmCustomEvent } from "@helpers/analytics";
import { isAllowInterest, isAllowWhatsapp } from "@config/feature";

export const TitleStyled = css({
  fontSize: 32,
  lineHeight: "50px",
  marginBottom: 20,
});

const ContainerInterest: React.FC<{
  productImage: TImage;
  productName: string;
  pathLevel: string;
}> = (props) => {
  const { t } = useTranslation("common");
  const { productImage, productName, pathLevel } = props;
  const classes = useStyles();

  const onClickWa = () => {
    const timeoutFetch = setTimeout(() => {
      gtmCustomEvent(
        {
          eventAction: `Klik WA - Produk ${productName}`,
          eventCategory: "Klik WA",
          eventLabel: `Klik WA - Produk ${productName}`,
        },
        "LeadProduct",
      );
    }, 1000);
    window.open(getAdminWA(productName), "_blank");
    return () => window.clearTimeout(timeoutFetch);
  };

  return (
    <Box
      paddingY="60px"
      borderRadius="16px"
      textAlign="center"
      sx={{
        background: `
          linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.8)),
          url("${productImage?.mediaPath}") center/cover no-repeat`,
      }}
    >
      <Box maxWidth={680} margin="auto">
        <Text css={TitleStyled} variant="h2" weight="700" color="white">
          {t("pdp.interest.title")} {productName}
        </Text>
        <Box mb="40px">
          <Text variant="body1" color="white">
            {t("pdp.interest.desc")} {productName}
          </Text>
        </Box>
      </Box>
      <Box className={classes.interestButtonContainer}>
        {isAllowWhatsapp && (
          <Button
            onClick={onClickWa}
            size="large"
            variant="outlined"
            width="230px"
            className={classes.whatsAppButton}
            startIcon={<img src={IMG_WHATSAPP} alt="whatsapp" />}
          >
            {t("interest.whatsapp")}
          </Button>
        )}
        {isAllowInterest && (
          <NextLink href={`${pathLevel}/interest-form`} passHref>
            <Button size="large" width="230px">
              {t("pdp.interest.button")}
            </Button>
          </NextLink>
        )}
      </Box>
    </Box>
  );
};

export default ContainerInterest;
